import axios from "axios";

const axiosInstance = axios.create({ 
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

const handleError = (error) => {
  if (error.response) {
    console.error("Data:", error.response.data);
    console.error("Status:", error.response.status);
    console.error("Headers:", error.response.headers);
    return `Error: ${error.response.status} - ${
      error.response.data.message || "Unknown error"
    }`;
  } else if (error.request) {
    // Request was made but no response received
    console.error("Request:", error.request);
    return "Error: No response received from the server";
  } else {
    // Something else happened while setting up the request
    console.error("Error Message:", error.message);
    return `Error: ${error.message}`;
  }
};

  
let baseUrl = "https://fynito.com/user";


export { axiosInstance, handleError, baseUrl };
